// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-survey {
    background-color: #eaf3f8;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  
  .data-survey .div {
    background-color: #eaf3f8;
    border: 1px none;
    height: 1080px;
    overflow: hidden;
    position: relative;
    width: 1920px;
  }
  
  .data-survey .overlap {
    height: 1012px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 1922px;
  }
  
  .data-survey .overlap-group {
    height: 1012px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1922px;
  }
  
  .data-survey .header-bar {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #d9d9d9;
    height: 102px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1922px;
  }
  
  .data-survey .header-DATA {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 113px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 34px;
  }
  
  .data-survey .logo-SIVINA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    height: 60px;
    left: 33px;
    position: absolute;
    top: 21px;
    width: 60px;
  }
  
  .data-survey .action-project {
    color: #000000;
    font-family: "Montserrat-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 1333px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 36px;
  }
  
  .data-survey .action-dashboard {
    color: #000000;
    font-family: "Montserrat-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 1651px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 36px;
  }
  
  .data-survey .profile-icon {
    background-color: #49bc92;
    border-radius: 25px;
    height: 50px;
    left: 1841px;
    position: absolute;
    top: 26px;
    width: 50px;
  }
  
  .data-survey .s {
    height: 18px;
    left: 19px;
    position: absolute;
    top: 16px;
    width: 13px;
  }
  
  .data-survey .action-filter-kota {
    height: 100px;
    left: 685px;
    position: absolute;
    top: 85px;
    width: 323px;
  }
  
  .data-survey .overlap-2 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    top: 31px;
    width: 321px;
  }
  
  .data-survey .text-wrapper {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .data-survey .polygon {
    height: 13px;
    left: 291px;
    position: absolute;
    top: 10px;
    width: 15px;
  }
  
  .data-survey .table {
    height: 840px;
    left: 32px;
    position: absolute;
    top: 172px;
    width: 1857px;
  }
  
  .data-survey .baris-isi {
    height: 765px;
    left: 0;
    overflow: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 75px;
    width: 1857px;
  }
  
  .data-survey .div-wrapper {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .data-survey .text-wrapper-2 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 59px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-3 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 220px;
  }
  
  .data-survey .text-wrapper-3 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 67px;
    letter-spacing: 1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 12px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-4 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 0;
    width: 176px;
  }
  
  .data-survey .text-wrapper-4 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 43px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 0;
    width: 182px;
  }
  
  .data-survey .text-wrapper-5 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 50px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .rectangle {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .data-survey .overlap-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .text-wrapper-6 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 70px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 0;
    width: 208px;
  }
  
  .data-survey .text-wrapper-7 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 32px;
    letter-spacing: 1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 12px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-group-2 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .text-wrapper-8 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 38px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .text-wrapper-9 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 80px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 55px;
    width: 131px;
  }
  
  .data-survey .overlap-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 55px;
    width: 220px;
  }
  
  .data-survey .overlap-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 55px;
    width: 176px;
  }
  
  .data-survey .overlap-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 55px;
    width: 182px;
  }
  
  .data-survey .text-wrapper-10 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 65px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .rectangle-2 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 55px;
    width: 180px;
  }
  
  .data-survey .overlap-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 55px;
    width: 240px;
  }
  
  .data-survey .overlap-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 55px;
    width: 208px;
  }
  
  .data-survey .text-wrapper-11 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 69px;
    letter-spacing: 1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 12px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 55px;
    width: 240px;
  }
  
  .data-survey .overlap-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 55px;
    width: 240px;
  }
  
  .data-survey .text-wrapper-12 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 82px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 110px;
    width: 131px;
  }
  
  .data-survey .overlap-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 110px;
    width: 220px;
  }
  
  .data-survey .overlap-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 110px;
    width: 176px;
  }
  
  .data-survey .overlap-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 110px;
    width: 182px;
  }
  
  .data-survey .rectangle-3 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 110px;
    width: 180px;
  }
  
  .data-survey .overlap-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 110px;
    width: 240px;
  }
  
  .data-survey .overlap-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 110px;
    width: 208px;
  }
  
  .data-survey .text-wrapper-13 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 23px;
    letter-spacing: 1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 12px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 110px;
    width: 240px;
  }
  
  .data-survey .overlap-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 110px;
    width: 240px;
  }
  
  .data-survey .text-wrapper-14 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 73px;
    letter-spacing: 1.1px;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .data-survey .overlap-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 165px;
    width: 131px;
  }
  
  .data-survey .overlap-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 220px;
    width: 131px;
  }
  
  .data-survey .rectangle-4 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 275px;
    width: 131px;
  }
  
  .data-survey .rectangle-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 330px;
    width: 131px;
  }
  
  .data-survey .rectangle-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 385px;
    width: 131px;
  }
  
  .data-survey .rectangle-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 440px;
    width: 131px;
  }
  
  .data-survey .rectangle-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 495px;
    width: 131px;
  }
  
  .data-survey .rectangle-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 550px;
    width: 131px;
  }
  
  .data-survey .rectangle-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 605px;
    width: 131px;
  }
  
  .data-survey .rectangle-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 660px;
    width: 131px;
  }
  
  .data-survey .rectangle-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 715px;
    width: 131px;
  }
  
  .data-survey .rectangle-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 770px;
    width: 131px;
  }
  
  .data-survey .overlap-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 165px;
    width: 220px;
  }
  
  .data-survey .overlap-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 220px;
    width: 220px;
  }
  
  .data-survey .rectangle-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 275px;
    width: 220px;
  }
  
  .data-survey .rectangle-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 330px;
    width: 220px;
  }
  
  .data-survey .rectangle-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 385px;
    width: 220px;
  }
  
  .data-survey .rectangle-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 440px;
    width: 220px;
  }
  
  .data-survey .rectangle-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 495px;
    width: 220px;
  }
  
  .data-survey .rectangle-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 550px;
    width: 220px;
  }
  
  .data-survey .rectangle-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 605px;
    width: 220px;
  }
  
  .data-survey .rectangle-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 660px;
    width: 220px;
  }
  
  .data-survey .rectangle-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 715px;
    width: 220px;
  }
  
  .data-survey .rectangle-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 770px;
    width: 220px;
  }
  
  .data-survey .overlap-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 165px;
    width: 176px;
  }
  
  .data-survey .overlap-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 220px;
    width: 176px;
  }
  
  .data-survey .rectangle-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 275px;
    width: 176px;
  }
  
  .data-survey .rectangle-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 330px;
    width: 176px;
  }
  
  .data-survey .rectangle-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 385px;
    width: 176px;
  }
  
  .data-survey .rectangle-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 440px;
    width: 176px;
  }
  
  .data-survey .rectangle-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 495px;
    width: 176px;
  }
  
  .data-survey .rectangle-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 550px;
    width: 176px;
  }
  
  .data-survey .rectangle-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 605px;
    width: 176px;
  }
  
  .data-survey .rectangle-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 660px;
    width: 176px;
  }
  
  .data-survey .rectangle-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 715px;
    width: 176px;
  }
  
  .data-survey .rectangle-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 770px;
    width: 176px;
  }
  
  .data-survey .overlap-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 165px;
    width: 182px;
  }
  
  .data-survey .overlap-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 220px;
    width: 182px;
  }
  
  .data-survey .rectangle-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 275px;
    width: 182px;
  }
  
  .data-survey .rectangle-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 330px;
    width: 182px;
  }
  
  .data-survey .rectangle-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 385px;
    width: 182px;
  }
  
  .data-survey .rectangle-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 440px;
    width: 182px;
  }
  
  .data-survey .rectangle-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 495px;
    width: 182px;
  }
  
  .data-survey .rectangle-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 550px;
    width: 182px;
  }
  
  .data-survey .rectangle-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 605px;
    width: 182px;
  }
  
  .data-survey .rectangle-41 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 660px;
    width: 182px;
  }
  
  .data-survey .rectangle-42 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 715px;
    width: 182px;
  }
  
  .data-survey .rectangle-43 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 770px;
    width: 182px;
  }
  
  .data-survey .rectangle-44 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 165px;
    width: 180px;
  }
  
  .data-survey .rectangle-45 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 220px;
    width: 180px;
  }
  
  .data-survey .rectangle-46 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 275px;
    width: 180px;
  }
  
  .data-survey .rectangle-47 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 330px;
    width: 180px;
  }
  
  .data-survey .rectangle-48 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 385px;
    width: 180px;
  }
  
  .data-survey .rectangle-49 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 440px;
    width: 180px;
  }
  
  .data-survey .rectangle-50 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 495px;
    width: 180px;
  }
  
  .data-survey .rectangle-51 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 550px;
    width: 180px;
  }
  
  .data-survey .rectangle-52 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 605px;
    width: 180px;
  }
  
  .data-survey .rectangle-53 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 660px;
    width: 180px;
  }
  
  .data-survey .rectangle-54 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 715px;
    width: 180px;
  }
  
  .data-survey .rectangle-55 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 770px;
    width: 180px;
  }
  
  .data-survey .overlap-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 165px;
    width: 240px;
  }
  
  .data-survey .overlap-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 220px;
    width: 240px;
  }
  
  .data-survey .rectangle-56 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 275px;
    width: 240px;
  }
  
  .data-survey .rectangle-57 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 330px;
    width: 240px;
  }
  
  .data-survey .rectangle-58 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 385px;
    width: 240px;
  }
  
  .data-survey .rectangle-59 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 440px;
    width: 240px;
  }
  
  .data-survey .rectangle-60 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 495px;
    width: 240px;
  }
  
  .data-survey .rectangle-61 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 550px;
    width: 240px;
  }
  
  .data-survey .rectangle-62 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 605px;
    width: 240px;
  }
  
  .data-survey .rectangle-63 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 660px;
    width: 240px;
  }
  
  .data-survey .rectangle-64 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 715px;
    width: 240px;
  }
  
  .data-survey .rectangle-65 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 770px;
    width: 240px;
  }
  
  .data-survey .overlap-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 165px;
    width: 208px;
  }
  
  .data-survey .overlap-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 220px;
    width: 208px;
  }
  
  .data-survey .rectangle-66 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 275px;
    width: 208px;
  }
  
  .data-survey .rectangle-67 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 330px;
    width: 208px;
  }
  
  .data-survey .rectangle-68 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 385px;
    width: 208px;
  }
  
  .data-survey .rectangle-69 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 440px;
    width: 208px;
  }
  
  .data-survey .rectangle-70 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 495px;
    width: 208px;
  }
  
  .data-survey .rectangle-71 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 550px;
    width: 208px;
  }
  
  .data-survey .rectangle-72 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 605px;
    width: 208px;
  }
  
  .data-survey .rectangle-73 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 660px;
    width: 208px;
  }
  
  .data-survey .rectangle-74 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 715px;
    width: 208px;
  }
  
  .data-survey .rectangle-75 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 770px;
    width: 208px;
  }
  
  .data-survey .overlap-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 165px;
    width: 240px;
  }
  
  .data-survey .overlap-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 220px;
    width: 240px;
  }
  
  .data-survey .rectangle-76 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 275px;
    width: 240px;
  }
  
  .data-survey .rectangle-77 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 330px;
    width: 240px;
  }
  
  .data-survey .rectangle-78 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 385px;
    width: 240px;
  }
  
  .data-survey .rectangle-79 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 440px;
    width: 240px;
  }
  
  .data-survey .rectangle-80 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 495px;
    width: 240px;
  }
  
  .data-survey .rectangle-81 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 550px;
    width: 240px;
  }
  
  .data-survey .rectangle-82 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 605px;
    width: 240px;
  }
  
  .data-survey .rectangle-83 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 660px;
    width: 240px;
  }
  
  .data-survey .rectangle-84 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 715px;
    width: 240px;
  }
  
  .data-survey .rectangle-85 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 770px;
    width: 240px;
  }
  
  .data-survey .overlap-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 165px;
    width: 240px;
  }
  
  .data-survey .overlap-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 220px;
    width: 240px;
  }
  
  .data-survey .rectangle-86 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 275px;
    width: 240px;
  }
  
  .data-survey .rectangle-87 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 330px;
    width: 240px;
  }
  
  .data-survey .rectangle-88 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 385px;
    width: 240px;
  }
  
  .data-survey .rectangle-89 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 440px;
    width: 240px;
  }
  
  .data-survey .rectangle-90 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 495px;
    width: 240px;
  }
  
  .data-survey .rectangle-91 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 550px;
    width: 240px;
  }
  
  .data-survey .rectangle-92 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 605px;
    width: 240px;
  }
  
  .data-survey .rectangle-93 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 660px;
    width: 240px;
  }
  
  .data-survey .rectangle-94 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 715px;
    width: 240px;
  }
  
  .data-survey .rectangle-95 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 770px;
    width: 240px;
  }
  
  .data-survey .rectangle-96 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 825px;
    width: 131px;
  }
  
  .data-survey .rectangle-97 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 825px;
    width: 220px;
  }
  
  .data-survey .rectangle-98 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 825px;
    width: 176px;
  }
  
  .data-survey .rectangle-99 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 825px;
    width: 182px;
  }
  
  .data-survey .rectangle-100 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 825px;
    width: 180px;
  }
  
  .data-survey .rectangle-101 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 825px;
    width: 240px;
  }
  
  .data-survey .rectangle-102 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 825px;
    width: 208px;
  }
  
  .data-survey .rectangle-103 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 825px;
    width: 240px;
  }
  
  .data-survey .rectangle-104 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 825px;
    width: 240px;
  }
  
  .data-survey .rectangle-105 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 880px;
    width: 131px;
  }
  
  .data-survey .rectangle-106 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 935px;
    width: 131px;
  }
  
  .data-survey .rectangle-107 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 990px;
    width: 131px;
  }
  
  .data-survey .rectangle-108 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1045px;
    width: 131px;
  }
  
  .data-survey .rectangle-109 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1100px;
    width: 131px;
  }
  
  .data-survey .rectangle-110 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1155px;
    width: 131px;
  }
  
  .data-survey .rectangle-111 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1210px;
    width: 131px;
  }
  
  .data-survey .rectangle-112 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1265px;
    width: 131px;
  }
  
  .data-survey .rectangle-113 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1320px;
    width: 131px;
  }
  
  .data-survey .rectangle-114 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 880px;
    width: 220px;
  }
  
  .data-survey .rectangle-115 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 935px;
    width: 220px;
  }
  
  .data-survey .rectangle-116 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 990px;
    width: 220px;
  }
  
  .data-survey .rectangle-117 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1045px;
    width: 220px;
  }
  
  .data-survey .rectangle-118 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1100px;
    width: 220px;
  }
  
  .data-survey .rectangle-119 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1155px;
    width: 220px;
  }
  
  .data-survey .rectangle-120 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1210px;
    width: 220px;
  }
  
  .data-survey .rectangle-121 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1265px;
    width: 220px;
  }
  
  .data-survey .rectangle-122 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1320px;
    width: 220px;
  }
  
  .data-survey .rectangle-123 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 880px;
    width: 176px;
  }
  
  .data-survey .rectangle-124 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 935px;
    width: 176px;
  }
  
  .data-survey .rectangle-125 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 990px;
    width: 176px;
  }
  
  .data-survey .rectangle-126 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1045px;
    width: 176px;
  }
  
  .data-survey .rectangle-127 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1100px;
    width: 176px;
  }
  
  .data-survey .rectangle-128 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1155px;
    width: 176px;
  }
  
  .data-survey .rectangle-129 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1210px;
    width: 176px;
  }
  
  .data-survey .rectangle-130 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1265px;
    width: 176px;
  }
  
  .data-survey .rectangle-131 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1320px;
    width: 176px;
  }
  
  .data-survey .rectangle-132 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 880px;
    width: 182px;
  }
  
  .data-survey .rectangle-133 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 935px;
    width: 182px;
  }
  
  .data-survey .rectangle-134 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 990px;
    width: 182px;
  }
  
  .data-survey .rectangle-135 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1045px;
    width: 182px;
  }
  
  .data-survey .rectangle-136 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1100px;
    width: 182px;
  }
  
  .data-survey .rectangle-137 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1155px;
    width: 182px;
  }
  
  .data-survey .rectangle-138 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1210px;
    width: 182px;
  }
  
  .data-survey .rectangle-139 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1265px;
    width: 182px;
  }
  
  .data-survey .rectangle-140 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1320px;
    width: 182px;
  }
  
  .data-survey .rectangle-141 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 880px;
    width: 180px;
  }
  
  .data-survey .rectangle-142 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 935px;
    width: 180px;
  }
  
  .data-survey .rectangle-143 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 990px;
    width: 180px;
  }
  
  .data-survey .rectangle-144 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1045px;
    width: 180px;
  }
  
  .data-survey .rectangle-145 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1100px;
    width: 180px;
  }
  
  .data-survey .rectangle-146 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1155px;
    width: 180px;
  }
  
  .data-survey .rectangle-147 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1210px;
    width: 180px;
  }
  
  .data-survey .rectangle-148 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1265px;
    width: 180px;
  }
  
  .data-survey .rectangle-149 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1320px;
    width: 180px;
  }
  
  .data-survey .rectangle-150 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 880px;
    width: 240px;
  }
  
  .data-survey .rectangle-151 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 935px;
    width: 240px;
  }
  
  .data-survey .rectangle-152 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 990px;
    width: 240px;
  }
  
  .data-survey .rectangle-153 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1045px;
    width: 240px;
  }
  
  .data-survey .rectangle-154 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1100px;
    width: 240px;
  }
  
  .data-survey .rectangle-155 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1155px;
    width: 240px;
  }
  
  .data-survey .rectangle-156 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1210px;
    width: 240px;
  }
  
  .data-survey .rectangle-157 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1265px;
    width: 240px;
  }
  
  .data-survey .rectangle-158 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 974px;
    position: absolute;
    top: 1320px;
    width: 240px;
  }
  
  .data-survey .rectangle-159 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 880px;
    width: 208px;
  }
  
  .data-survey .rectangle-160 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 935px;
    width: 208px;
  }
  
  .data-survey .rectangle-161 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 990px;
    width: 208px;
  }
  
  .data-survey .rectangle-162 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1045px;
    width: 208px;
  }
  
  .data-survey .rectangle-163 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1100px;
    width: 208px;
  }
  
  .data-survey .rectangle-164 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1155px;
    width: 208px;
  }
  
  .data-survey .rectangle-165 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1210px;
    width: 208px;
  }
  
  .data-survey .rectangle-166 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1265px;
    width: 208px;
  }
  
  .data-survey .rectangle-167 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1464px;
    position: absolute;
    top: 1320px;
    width: 208px;
  }
  
  .data-survey .rectangle-168 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 880px;
    width: 240px;
  }
  
  .data-survey .rectangle-169 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 935px;
    width: 240px;
  }
  
  .data-survey .rectangle-170 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 990px;
    width: 240px;
  }
  
  .data-survey .rectangle-171 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1045px;
    width: 240px;
  }
  
  .data-survey .rectangle-172 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1100px;
    width: 240px;
  }
  
  .data-survey .rectangle-173 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1155px;
    width: 240px;
  }
  
  .data-survey .rectangle-174 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1210px;
    width: 240px;
  }
  
  .data-survey .rectangle-175 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1265px;
    width: 240px;
  }
  
  .data-survey .rectangle-176 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1219px;
    position: absolute;
    top: 1320px;
    width: 240px;
  }
  
  .data-survey .rectangle-177 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 880px;
    width: 240px;
  }
  
  .data-survey .rectangle-178 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 935px;
    width: 240px;
  }
  
  .data-survey .rectangle-179 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 990px;
    width: 240px;
  }
  
  .data-survey .rectangle-180 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1045px;
    width: 240px;
  }
  
  .data-survey .rectangle-181 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1100px;
    width: 240px;
  }
  
  .data-survey .rectangle-182 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1155px;
    width: 240px;
  }
  
  .data-survey .rectangle-183 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1210px;
    width: 240px;
  }
  
  .data-survey .rectangle-184 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1265px;
    width: 240px;
  }
  
  .data-survey .rectangle-185 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1320px;
    width: 240px;
  }
  
  .data-survey .header-tabel {
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1857px;
  }
  
  .data-survey .rectangle-186 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .data-survey .rectangle-187 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 220px;
  }
  
  .data-survey .rectangle-188 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 793px;
    position: absolute;
    top: 0;
    width: 176px;
  }
  
  .data-survey .rectangle-189 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 606px;
    position: absolute;
    top: 0;
    width: 182px;
  }
  
  .data-survey .rectangle-190 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .data-survey .rectangle-191 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1464px;
    position: absolute;
    top: 0;
    width: 208px;
  }
  
  .data-survey .rectangle-192 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1219px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .rectangle-193 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 974px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .rectangle-194 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 361px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .data-survey .text-wrapper-15 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 444px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 138px;
  }
  
  .data-survey .text-wrapper-16 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 80px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 34px;
  }
  
  .data-survey .text-wrapper-17 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 21.8px;
    font-weight: 500;
    left: 226px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 103px;
  }
  
  .data-survey .text-wrapper-18 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 655px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 148px;
  }
  
  .data-survey .text-wrapper-19 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1041px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 184px;
  }
  
  .data-survey .text-wrapper-20 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1299px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 143px;
  }
  
  .data-survey .text-wrapper-21 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 850px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 125px;
  }
  
  .data-survey .text-wrapper-22 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1515px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 168px;
  }
  
  .data-survey .text-wrapper-23 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1756px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 192px;
    width: 87px;
  }
  
  .data-survey .action-filter {
    height: 40px;
    left: 33px;
    position: absolute;
    top: 116px;
    width: 323px;
  }
  
  .data-survey .overlap-41 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 321px;
  }
  
  .data-survey .overlap-wrapper {
    height: 40px;
    left: 359px;
    position: absolute;
    top: 116px;
    width: 323px;
  }
  
  .data-survey .overlap-group-wrapper {
    height: 40px;
    left: 1011px;
    position: absolute;
    top: 116px;
    width: 323px;
  }
  
  .data-survey .button-download {
    height: 40px;
    left: 1671px;
    position: absolute;
    top: 116px;
    width: 222px;
  }
  
  .data-survey .overlap-42 {
    background-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 220px;
  }
  
  .data-survey .text-wrapper-24 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 66px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .data-survey .caption-menampilkan {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 813px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 1030px;
    white-space: nowrap;
  }
  
  .data-survey .page {
    height: 35px;
    left: 1640px;
    position: absolute;
    top: 1027px;
    width: 257px;
  }
  
  .data-survey .text-wrapper-25 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 45px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .data-survey .text-wrapper-26 {
    color: #000000;
    font-family: "Roboto-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 0;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .data-survey .button-next {
    height: 35px;
    left: 169px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .data-survey .overlap-group-3 {
    background-color: #069dae;
    border-radius: 5px;
    height: 35px;
    position: relative;
    width: 35px;
  }
  
  .data-survey .text-wrapper-27 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .data-survey .text-wrapper-28 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 87px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .data-survey .text-wrapper-29 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 135px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 3px;
    white-space: nowrap;
  }
  
  .data-survey .button-end {
    height: 35px;
    left: 214px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .data-survey .text-wrapper-30 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 2px;
    white-space: nowrap;
  }
  
  .data-survey .vector-stroke {
    height: 6px;
    left: 13px;
    position: absolute;
    top: 19px;
    width: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/style/data.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yDAAmD;IACnD,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb","sourcesContent":[".data-survey {\n    background-color: #eaf3f8;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .data-survey .div {\n    background-color: #eaf3f8;\n    border: 1px none;\n    height: 1080px;\n    overflow: hidden;\n    position: relative;\n    width: 1920px;\n  }\n  \n  .data-survey .overlap {\n    height: 1012px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 1922px;\n  }\n  \n  .data-survey .overlap-group {\n    height: 1012px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1922px;\n  }\n  \n  .data-survey .header-bar {\n    background-color: #ffffff;\n    border: 1px solid;\n    border-color: #d9d9d9;\n    height: 102px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1922px;\n  }\n  \n  .data-survey .header-DATA {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 113px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 34px;\n  }\n  \n  .data-survey .logo-SIVINA {\n    background-image: url(../assets/images/bg/logo.png);\n    background-size: 100% 100%;\n    height: 60px;\n    left: 33px;\n    position: absolute;\n    top: 21px;\n    width: 60px;\n  }\n  \n  .data-survey .action-project {\n    color: #000000;\n    font-family: \"Montserrat-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 1333px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 36px;\n  }\n  \n  .data-survey .action-dashboard {\n    color: #000000;\n    font-family: \"Montserrat-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 1651px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 36px;\n  }\n  \n  .data-survey .profile-icon {\n    background-color: #49bc92;\n    border-radius: 25px;\n    height: 50px;\n    left: 1841px;\n    position: absolute;\n    top: 26px;\n    width: 50px;\n  }\n  \n  .data-survey .s {\n    height: 18px;\n    left: 19px;\n    position: absolute;\n    top: 16px;\n    width: 13px;\n  }\n  \n  .data-survey .action-filter-kota {\n    height: 100px;\n    left: 685px;\n    position: absolute;\n    top: 85px;\n    width: 323px;\n  }\n  \n  .data-survey .overlap-2 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    top: 31px;\n    width: 321px;\n  }\n  \n  .data-survey .text-wrapper {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .polygon {\n    height: 13px;\n    left: 291px;\n    position: absolute;\n    top: 10px;\n    width: 15px;\n  }\n  \n  .data-survey .table {\n    height: 840px;\n    left: 32px;\n    position: absolute;\n    top: 172px;\n    width: 1857px;\n  }\n  \n  .data-survey .baris-isi {\n    height: 765px;\n    left: 0;\n    overflow: hidden;\n    overflow-y: scroll;\n    position: absolute;\n    top: 75px;\n    width: 1857px;\n  }\n  \n  .data-survey .div-wrapper {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .data-survey .text-wrapper-2 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 59px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-3 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 220px;\n  }\n  \n  .data-survey .text-wrapper-3 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 67px;\n    letter-spacing: 1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 12px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-4 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 0;\n    width: 176px;\n  }\n  \n  .data-survey .text-wrapper-4 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 43px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 0;\n    width: 182px;\n  }\n  \n  .data-survey .text-wrapper-5 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 50px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .rectangle {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .data-survey .overlap-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-6 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 70px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 0;\n    width: 208px;\n  }\n  \n  .data-survey .text-wrapper-7 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 32px;\n    letter-spacing: 1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 12px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-group-2 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-8 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 38px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-9 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 80px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 55px;\n    width: 131px;\n  }\n  \n  .data-survey .overlap-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 55px;\n    width: 220px;\n  }\n  \n  .data-survey .overlap-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 55px;\n    width: 176px;\n  }\n  \n  .data-survey .overlap-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 55px;\n    width: 182px;\n  }\n  \n  .data-survey .text-wrapper-10 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 65px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .rectangle-2 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 55px;\n    width: 180px;\n  }\n  \n  .data-survey .overlap-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 55px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 55px;\n    width: 208px;\n  }\n  \n  .data-survey .text-wrapper-11 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 69px;\n    letter-spacing: 1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 12px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 55px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 55px;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-12 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 82px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 110px;\n    width: 131px;\n  }\n  \n  .data-survey .overlap-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 110px;\n    width: 220px;\n  }\n  \n  .data-survey .overlap-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 110px;\n    width: 176px;\n  }\n  \n  .data-survey .overlap-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 110px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-3 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 110px;\n    width: 180px;\n  }\n  \n  .data-survey .overlap-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 110px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 110px;\n    width: 208px;\n  }\n  \n  .data-survey .text-wrapper-13 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 23px;\n    letter-spacing: 1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 12px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 110px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 110px;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-14 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 73px;\n    letter-spacing: 1.1px;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .overlap-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 165px;\n    width: 131px;\n  }\n  \n  .data-survey .overlap-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 220px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-4 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 275px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 330px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 385px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 440px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 495px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 550px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 605px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 660px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 715px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 770px;\n    width: 131px;\n  }\n  \n  .data-survey .overlap-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 165px;\n    width: 220px;\n  }\n  \n  .data-survey .overlap-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 220px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 275px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 330px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 385px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 440px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 495px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 550px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 605px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 660px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 715px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 770px;\n    width: 220px;\n  }\n  \n  .data-survey .overlap-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 165px;\n    width: 176px;\n  }\n  \n  .data-survey .overlap-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 220px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 275px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 330px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 385px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 440px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 495px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 550px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 605px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 660px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 715px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 770px;\n    width: 176px;\n  }\n  \n  .data-survey .overlap-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 165px;\n    width: 182px;\n  }\n  \n  .data-survey .overlap-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 220px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 275px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 330px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 385px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 440px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 495px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 550px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 605px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-41 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 660px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-42 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 715px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-43 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 770px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-44 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 165px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-45 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 220px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-46 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 275px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-47 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 330px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-48 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 385px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-49 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 440px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-50 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 495px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-51 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 550px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-52 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 605px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-53 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 660px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-54 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 715px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-55 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 770px;\n    width: 180px;\n  }\n  \n  .data-survey .overlap-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 165px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 220px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-56 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 275px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-57 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 330px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-58 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 385px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-59 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 440px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-60 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 495px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-61 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 550px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-62 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 605px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-63 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 660px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-64 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 715px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-65 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 770px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 165px;\n    width: 208px;\n  }\n  \n  .data-survey .overlap-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 220px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-66 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 275px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-67 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 330px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-68 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 385px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-69 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 440px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-70 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 495px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-71 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 550px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-72 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 605px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-73 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 660px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-74 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 715px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-75 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 770px;\n    width: 208px;\n  }\n  \n  .data-survey .overlap-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 165px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 220px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-76 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 275px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-77 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 330px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-78 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 385px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-79 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 440px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-80 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 495px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-81 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 550px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-82 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 605px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-83 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 660px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-84 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 715px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-85 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 770px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 165px;\n    width: 240px;\n  }\n  \n  .data-survey .overlap-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 220px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-86 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 275px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-87 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 330px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-88 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 385px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-89 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 440px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-90 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 495px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-91 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 550px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-92 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 605px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-93 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 660px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-94 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 715px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-95 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 770px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-96 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 825px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-97 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 825px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-98 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 825px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-99 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 825px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-100 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 825px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-101 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 825px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-102 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 825px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-103 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 825px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-104 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 825px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-105 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 880px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-106 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 935px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-107 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 990px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-108 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1045px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-109 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1100px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-110 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1155px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-111 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1210px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-112 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1265px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-113 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1320px;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-114 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 880px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-115 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 935px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-116 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 990px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-117 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1045px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-118 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1100px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-119 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1155px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-120 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1210px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-121 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1265px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-122 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1320px;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-123 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 880px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-124 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 935px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-125 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 990px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-126 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1045px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-127 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1100px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-128 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1155px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-129 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1210px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-130 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1265px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-131 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1320px;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-132 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 880px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-133 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 935px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-134 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 990px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-135 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1045px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-136 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1100px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-137 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1155px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-138 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1210px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-139 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1265px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-140 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1320px;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-141 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 880px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-142 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 935px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-143 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 990px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-144 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1045px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-145 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1100px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-146 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1155px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-147 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1210px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-148 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1265px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-149 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1320px;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-150 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 880px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-151 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 935px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-152 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 990px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-153 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1045px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-154 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1100px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-155 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1155px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-156 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1210px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-157 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1265px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-158 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 974px;\n    position: absolute;\n    top: 1320px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-159 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 880px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-160 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 935px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-161 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 990px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-162 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1045px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-163 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1100px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-164 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1155px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-165 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1210px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-166 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1265px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-167 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1464px;\n    position: absolute;\n    top: 1320px;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-168 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 880px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-169 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 935px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-170 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 990px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-171 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1045px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-172 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1100px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-173 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1155px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-174 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1210px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-175 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1265px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-176 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1219px;\n    position: absolute;\n    top: 1320px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-177 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 880px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-178 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 935px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-179 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 990px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-180 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1045px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-181 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1100px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-182 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1155px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-183 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1210px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-184 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1265px;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-185 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1320px;\n    width: 240px;\n  }\n  \n  .data-survey .header-tabel {\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1857px;\n  }\n  \n  .data-survey .rectangle-186 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .data-survey .rectangle-187 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 220px;\n  }\n  \n  .data-survey .rectangle-188 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 793px;\n    position: absolute;\n    top: 0;\n    width: 176px;\n  }\n  \n  .data-survey .rectangle-189 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 606px;\n    position: absolute;\n    top: 0;\n    width: 182px;\n  }\n  \n  .data-survey .rectangle-190 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .data-survey .rectangle-191 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1464px;\n    position: absolute;\n    top: 0;\n    width: 208px;\n  }\n  \n  .data-survey .rectangle-192 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1219px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-193 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 974px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .rectangle-194 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 361px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .data-survey .text-wrapper-15 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 444px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 138px;\n  }\n  \n  .data-survey .text-wrapper-16 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 80px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 34px;\n  }\n  \n  .data-survey .text-wrapper-17 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 21.8px;\n    font-weight: 500;\n    left: 226px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 103px;\n  }\n  \n  .data-survey .text-wrapper-18 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 655px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 148px;\n  }\n  \n  .data-survey .text-wrapper-19 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1041px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 184px;\n  }\n  \n  .data-survey .text-wrapper-20 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1299px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 143px;\n  }\n  \n  .data-survey .text-wrapper-21 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 850px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 125px;\n  }\n  \n  .data-survey .text-wrapper-22 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1515px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 168px;\n  }\n  \n  .data-survey .text-wrapper-23 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1756px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 192px;\n    width: 87px;\n  }\n  \n  .data-survey .action-filter {\n    height: 40px;\n    left: 33px;\n    position: absolute;\n    top: 116px;\n    width: 323px;\n  }\n  \n  .data-survey .overlap-41 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 321px;\n  }\n  \n  .data-survey .overlap-wrapper {\n    height: 40px;\n    left: 359px;\n    position: absolute;\n    top: 116px;\n    width: 323px;\n  }\n  \n  .data-survey .overlap-group-wrapper {\n    height: 40px;\n    left: 1011px;\n    position: absolute;\n    top: 116px;\n    width: 323px;\n  }\n  \n  .data-survey .button-download {\n    height: 40px;\n    left: 1671px;\n    position: absolute;\n    top: 116px;\n    width: 222px;\n  }\n  \n  .data-survey .overlap-42 {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 220px;\n  }\n  \n  .data-survey .text-wrapper-24 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 66px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .caption-menampilkan {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 813px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 1030px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .page {\n    height: 35px;\n    left: 1640px;\n    position: absolute;\n    top: 1027px;\n    width: 257px;\n  }\n  \n  .data-survey .text-wrapper-25 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 45px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .text-wrapper-26 {\n    color: #000000;\n    font-family: \"Roboto-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 0;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .button-next {\n    height: 35px;\n    left: 169px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .data-survey .overlap-group-3 {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 35px;\n    position: relative;\n    width: 35px;\n  }\n  \n  .data-survey .text-wrapper-27 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .text-wrapper-28 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 87px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .text-wrapper-29 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 135px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 3px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .button-end {\n    height: 35px;\n    left: 214px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .data-survey .text-wrapper-30 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 2px;\n    white-space: nowrap;\n  }\n  \n  .data-survey .vector-stroke {\n    height: 6px;\n    left: 13px;\n    position: absolute;\n    top: 19px;\n    width: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
